export const messages = {
  en: {
    activitiesManage: {
      search: {
        title: 'Search Conditions',
        activitiesId: 'Please enter activity ID',
        titlePlaceholder: 'Please enter title',
        typeCd: 'Please select activity type',
        staffName: 'Please enter publisher name'
      },
      list: {
        title: 'Activity List'
      },
      table: {
        activitiesId: 'Activity ID',
        title: 'Title',
        typeCd: 'Type',
        startTime: 'Start Time',
        endTime: 'End Time',
        userName: 'Publisher'
      },
      add: {
        title: 'Add Activity',
        titlePlaceholder: 'Required, please enter title',
        typeCd: 'Activity Type',
        startTime: 'start time',
        endTime: 'end time',
        typeCdPlaceholder: 'Required, please select type',
        isMoreCommunity: 'Multi-community',
        isMoreCommunityPlaceholder: 'Please select if multi-community',
        headerImg: 'Header Image (800*595)',
        startTimePlaceholder: 'Required, please enter start time',
        endTimePlaceholder: 'Required, please enter end time',
        context: 'Content'
      },
      edit: {
        title: 'Edit Activity',
        titlePlaceholder: 'Required, please enter title',
        typeCd: 'Activity Type',
        startTime: 'start time',
        endTime: 'end time',
        typeCdPlaceholder: 'Required, please select type',
        headerImg: 'Header Image (800*595)',
        startTimePlaceholder: 'Required, please enter start time',
        endTimePlaceholder: 'Required, please enter end time',
        context: 'Content'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete this activity?'
      },
      validate: {
        titleRequired: 'Title is required',
        titleMaxLength: 'Title cannot exceed 200 characters',
        typeCdRequired: 'Type is required',
        headerImgRequired: 'Header image is required',
        contextRequired: 'Content is required',
        startTimeRequired: 'Start time is required',
        endTimeRequired: 'End time is required',
        activitiesIdRequired: 'Activity ID is required',
        imageSize: 'Image size cannot exceed 2MB'
      }
    }
  },
  zh: {
    activitiesManage: {
      search: {
        title: '查询条件',
        activitiesId: '请输入活动ID',
        titlePlaceholder: '请输入标题',
        typeCd: '请选择活动类型',
        staffName: '请输入发布人名称'
      },
      list: {
        title: '活动列表'
      },
      table: {
        activitiesId: '活动ID',
        title: '标题',
        typeCd: '类型',
        startTime: '开始时间',
        endTime: '结束时间',
        userName: '发布人'
      },
      add: {
        title: '添加活动',
        titlePlaceholder: '必填，请输入标题',
        typeCd: '类型',
        startTime: '开始时间',
        endTime: '结束时间',
        typeCdPlaceholder: '必填，请选择类型',
        isMoreCommunity: '多小区',
        isMoreCommunityPlaceholder: '请选择是否多小区',
        headerImg: '头部照片(800*595)',
        startTimePlaceholder: '必填，请输入开始时间',
        endTimePlaceholder: '必填，请输入结束时间',
        context: '内容'
      },
      edit: {
        title: '编辑活动',
        titlePlaceholder: '必填，请输入标题',
        typeCd: '类型',
        typeCdPlaceholder: '必填，请选择类型',
        headerImg: '头部照片(800*595)',
        startTimePlaceholder: '必填，请输入开始时间',
        endTimePlaceholder: '必填，请输入结束时间',
        startTime: '开始时间',
        endTime: '结束时间',
        context: '内容'
      },
      delete: {
        title: '确认操作',
        confirmText: '确认删除该活动吗？'
      },
validate: {
        titleRequired: '标题不能为空',
        titleMaxLength: '标题不能超过200个字符',
        typeCdRequired: '类型不能为空',
        headerImgRequired: '头部照片不能为空',
        contextRequired: '内容不能为空',
        startTimeRequired: '开始时间不能为空',
        endTimeRequired: '结束时间不能为空',
        activitiesIdRequired: '活动ID不能为空',
        imageSize: '图片大小不能超过2MB'
      }
    }
  },
  'zh-TW': {
    activitiesManage: {
      search: {
        title: '查詢條件',
        activitiesId: '請輸入活動ID',
        titlePlaceholder: '請輸入標題',
        typeCd: '請選擇活動類型',
        staffName: '請輸入發布人名稱'
      },
      list: {
        title: '活動列表'
      },
      table: {
        activitiesId: '活動ID',
        title: '標題',
        typeCd: '類型',
        startTime: '開始時間',
        endTime: '結束時間',
        userName: '發布人'
      },
      add: {
        title: '添加活動',
        titlePlaceholder: '必填，請輸入標題',
        typeCd: '類型',
        startTime: '開始時間',
        endTime: '結束時間',
        typeCdPlaceholder: '必填，請選擇類型',
        isMoreCommunity: '多小區',
        isMoreCommunityPlaceholder: '請選擇是否多小區',
        headerImg: '頭部照片(800*595)',
        startTimePlaceholder: '必填，請輸入開始時間',
        endTimePlaceholder: '必填，請輸入結束時間',
        context: '內容'
      },
      edit: {
        title: '編輯活動',
        titlePlaceholder: '必填，請輸入標題',
        typeCd: '類型',
        typeCdPlaceholder: '必填，請選擇類型',
        headerImg: '頭部照片(800*595)',
        startTimePlaceholder: '必填，請輸入開始時間',
        endTimePlaceholder: '必填，請輸入結束時間',
        startTime: '開始時間',
        endTime: '結束時間',
        context: '內容'
      },
      delete: {
        title: '確認操作',
        confirmText: '確認刪除該活動嗎？'
      },
      validate: {
        titleRequired: '標題不能為空',
        titleMaxLength: '標題不能超過200個字符',
        typeCdRequired: '類型不能為空',
        headerImgRequired: '頭部照片不能為空',
        contextRequired: '內容不能為空',
        startTimeRequired: '開始時間不能為空',
        endTimeRequired: '結束時間不能為空',
        activitiesIdRequired: '活動ID不能為空',
        imageSize: '圖片大小不能超過2MB'
      }
    }
  }
}